import { px, rem } from "@certn/cascadia/utils";
import { CascadiaSpacing } from "@certn/cascadia-tokens";
import { css } from "@emotion/css";

import { Text } from "../../../../foundations/typography/Text";

interface Props {
  id?: string;
  className?: string;
  children?: React.ReactNode;
  testID?: string;
}

export function FormText({
  id,
  className,
  children,
  testID = "form-text",
}: Props) {
  if (!children) {
    return null;
  }

  return (
    <Text
      id={id}
      style="input/helper"
      color="text-weak"
      className={css(margin("space-1", "top"), { display: "block" }, className)}
      testID={testID}
    >
      {children}
    </Text>
  );
}

export function margin(
  spaceToken: CascadiaSpacing,
  type: "top" | "right" | "bottom" | "left" | "all",
  unit?: "rem" | "px"
) {
  switch (type) {
    case "top":
      return {
        marginTop: unit === "px" ? px(spaceToken) : rem(spaceToken),
      };
    case "right":
      return {
        marginRight: unit === "px" ? px(spaceToken) : rem(spaceToken),
      };
    case "bottom":
      return {
        marginBottom: unit === "px" ? px(spaceToken) : rem(spaceToken),
      };
    case "left":
      return {
        marginLeft: unit === "px" ? px(spaceToken) : rem(spaceToken),
      };
    default:
      return {
        margin: unit === "px" ? px(spaceToken) : rem(spaceToken),
      };
  }
}
